// Mock data for GEETH365 Healthcare Platform

export const mockOffers = [
  {
    id: 1,
    channel: 'pharmacy',
    title: 'Up to 20% OFF',
    subtitle: 'On prescription medicines',
    badge: 'Free Delivery',
    image: 'https://images.unsplash.com/photo-1659019479940-e3fd3fba24d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlfGVufDB8fHxvcmFuZ2V8MTc1ODgxOTg5MHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    channel: 'lab',
    title: '50% OFF',
    subtitle: 'Lab packages for subscribers',
    badge: 'Home Collection',
    image: 'https://images.unsplash.com/photo-1602052577122-f73b9710adba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxsYWJvcmF0b3J5fGVufDB8fHx8MTc1ODgxOTkzMHww&ixlib=rb-4.1.0&q=85'
  }
];

export const mockDoctors = [
  {
    id: 1,
    name: 'Dr. P.S. Varanasi',
    specialty: 'Pediatrician & General Consultant',
    qualification: 'M.D (PED)',
    rating: 5.0,
    experience: 'Most Experienced',
    photo: 'https://customer-assets.emergentagent.com/job_healthcare-hub-25/artifacts/0c43n95p_DR%20VARANSI.jpeg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['M.D (PED)', 'APMC Regn.no.: 6306', 'Civil Surgeon Rtd Prof.&HOD;KGH'],
    consultationFee: 300,
    availableSlots: ['10:00 AM', '11:00 AM', '4:00 PM', '5:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Most Experienced Pediatrician and General Consultant. Former Civil Surgeon and Professor & HOD at KGH. Specializes in child healthcare and general medical consultations.',
    services: ['Pediatric Care', 'General Consultation', 'Vaccination', 'Child Development', 'General Medicine']
  },
  {
    id: 2,
    name: 'Dr. Marupalli Ravi Kishore',
    specialty: 'Diabetologist & Physician',
    qualification: 'MBBS, MD (General Medicine) FIDM, FCC',
    rating: 5.0,
    experience: 'Expert Specialist',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/5ds4ttyn_DR.%20M.%20RAVI%20KISHORE.jpg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD (General Medicine)', 'APMC Regn.no.: 118337', 'FIDM, FCC Certified'],
    consultationFee: 400,
    availableSlots: ['9:00 AM', '10:30 AM', '3:30 PM', '5:30 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Expert Specialist in Diabetology and General Medicine. Consultant Diabetologist and Physician with advanced certifications in diabetes management and internal medicine.',
    services: ['Diabetes Management', 'General Medicine', 'Internal Medicine', 'Preventive Care', 'Metabolic Disorders']
  },
  {
    id: 3,
    name: 'Dr. J. Sarat Chandra',
    specialty: 'Pediatrician & Physician',
    qualification: 'MBBS, MD Paediatrics',
    rating: 5.0,
    experience: 'Highly Qualified',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/3tp3r0bm_DR%20SHARAT%20PAEDIATRICS.jpeg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD Paediatrics', 'APMC Regn.no.: 96848', 'Consultant Pediatrician'],
    consultationFee: 350,
    availableSlots: ['8:00 AM', '9:30 AM', '4:30 PM', '6:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Highly Qualified Consultant Pediatrician and Physician with specialized expertise in child healthcare and pediatric medicine.',
    services: ['Pediatric Care', 'Child Health Checkups', 'Vaccination', 'Growth Monitoring', 'Pediatric Consultation']
  },
  {
    id: 4,
    name: 'Dr. Chintada Mounika',
    specialty: 'Neurologist & Brain Stroke Specialist',
    qualification: 'MBBS, MD, DM Neurology',
    rating: 5.0,
    experience: 'Super Specialist',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/i7n8ahhy_DR%20C.%20MOUNIKA%20NEURO.jpeg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD, DM Neurology', 'APMC Regn.no.: 96736', 'Brain Stroke Specialist'],
    consultationFee: 500,
    availableSlots: ['10:00 AM', '11:30 AM', '3:00 PM', '4:30 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Super Specialist Consultant Neurologist with expertise in Brain Stroke and Neurocare. Advanced training in neurological disorders and stroke management.',
    services: ['Neurology Consultation', 'Brain Stroke Treatment', 'Neurocare', 'Neurological Disorders', 'Headache Management']
  },
  {
    id: 5,
    name: 'Dr. Suggu Sreeramu',
    specialty: 'Dermatologist & Cosmetology Specialist',
    qualification: 'MBBS, MD-DVL',
    rating: 5.0,
    experience: 'Leading Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/zpwtqwb8_DR%20SREE%20RAMU%20DERMATOLOGIST.jpeg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD-DVL', 'APMC Regn.no.: 76184', 'Cosmetology Specialist'],
    consultationFee: 450,
    availableSlots: ['9:00 AM', '10:00 AM', '2:00 PM', '5:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Leading Expert Consultant Dermatologist and Cosmetology Specialist with advanced expertise in skin care and cosmetic treatments.',
    services: ['Dermatology Consultation', 'Skin Care', 'Cosmetology', 'Skin Disorders', 'Cosmetic Treatments']
  },
  {
    id: 6,
    name: 'Dr. Sahithi Royal',
    specialty: 'Gynecologist & Obstetrics Specialist',
    qualification: 'MBBS, MS - Obstetrics & Gynecology',
    rating: 5.0,
    experience: 'Women\'s Health Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/ndmft3w1_DR%20SAHITHI%20GYNEC.jpeg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MS - Obstetrics & Gynecology', 'APMC Regn.no.: 96858', 'Women\'s Health Specialist'],
    consultationFee: 400,
    availableSlots: ['9:00 AM', '10:30 AM', '2:30 PM', '4:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Women\'s Health Expert Consultant Gynecologist and Obstetrics Specialist with expertise in women\'s healthcare and maternal care.',
    services: ['Gynecology Consultation', 'Obstetrics Care', 'Women\'s Health', 'Pregnancy Care', 'Maternal Health']
  },
  {
    id: 7,
    name: 'Dr. S. Venkata Padmavathi',
    specialty: 'Ophthalmologist & Cataract Specialist',
    qualification: 'MBBS, MS Ophthalmology',
    rating: 5.0,
    experience: 'Vision Care Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/6y8rlg90_DR.%20S.%20VENKATA%20PADMAVATHI%20%281%29.jpg',
    clinic: 'Eye Care Center',
    address: 'Rajamahendravaram, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MS Ophthalmology', 'APMC Regn.no.: 81191', 'Cataract Care Specialist'],
    consultationFee: 350,
    availableSlots: ['8:30 AM', '10:00 AM', '3:00 PM', '5:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Vision Care Expert Consultant Ophthalmologist and Cataract Care Specialist with advanced expertise in eye care and vision treatment.',
    services: ['Eye Examination', 'Cataract Surgery', 'Vision Care', 'Eye Disorders', 'Retinal Care']
  },
  {
    id: 8,
    name: 'Dr. Paidi Suresh Kumar',
    specialty: 'Cardiologist & Cardiac Stenting Specialist',
    qualification: 'MBBS, MD, DM Cardiology',
    rating: 5.0,
    experience: 'Heart Care Champion',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/q5y2zrd4_DR.%20P.%20SURESH%20KUMAR.jpg',
    clinic: 'Sri Sai Sagar Clinics',
    address: 'PM Palem, Visakhapatnam',
    distance: '0.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD, DM Cardiology', 'APMC Regn.no.: 79473', 'Interventional Cardiologist'],
    consultationFee: 600,
    availableSlots: ['8:00 AM', '9:30 AM', '2:00 PM', '4:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Heart Care Champion Consultant Cardiologist and Cardiac Stenting Specialist with expertise in interventional cardiology and advanced cardiac procedures.',
    services: ['Cardiology Consultation', 'Cardiac Stenting', 'Heart Care', 'Interventional Cardiology', 'Cardiac Emergencies']
  },
  {
    id: 9,
    name: 'Dr. R. Bharani',
    specialty: 'Pulmonologist & Emergency Care Specialist',
    qualification: 'MBBS, DNB Pulmonology',
    rating: 5.0,
    experience: 'Respiratory Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/6aoosidg_DR.%20BHARANI.jpg',
    clinic: 'Shri Hospital',
    address: 'Guntur, Andhra Pradesh',
    distance: '1.5 km',
    phone: '7337541113',
    achievements: ['MBBS, DNB Pulmonology', 'APMC Regn.no.: 81922', 'Emergency Care Specialist'],
    consultationFee: 450,
    availableSlots: ['9:00 AM', '11:00 AM', '3:00 PM', '5:30 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Respiratory Expert Consultant Pulmonologist and Emergency Care Specialist with advanced expertise in lung care and emergency medicine.',
    services: ['Pulmonology Consultation', 'Respiratory Care', 'Emergency Medicine', 'Lung Disorders', 'Critical Care']
  },
  {
    id: 10,
    name: 'Dr. T. Chandra Mouli',
    specialty: 'Critical Care & Sepsis Specialist',
    qualification: 'MBBS, MD, DM Critical Care Medicine DNB',
    rating: 5.0,
    experience: 'Life Saving Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/blaxxf9a_DR%20CHANDRAMOULI.jpg',
    clinic: 'R.A.C.C ICU Critical Care Unit',
    address: 'Rajamahendravaram, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD, DM Critical Care', 'APMC Regn.no.: 79586', 'Sepsis Specialist'],
    consultationFee: 500,
    availableSlots: ['7:00 AM', '8:30 AM', '6:00 PM', '7:30 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Life Saving Expert Critical Care and Sepsis Specialist with advanced training in intensive care medicine and life-saving procedures.',
    services: ['Critical Care', 'ICU Management', 'Sepsis Treatment', 'Emergency Medicine', 'Life Support Systems']
  },
  {
    id: 11,
    name: 'Dr. Kona Sunil Kumar',
    specialty: 'Neuro Psychiatrist',
    qualification: 'MBBS, MD - Neuro Psychiatry',
    rating: 5.0,
    experience: 'Mental Health Advocate',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/6ney502x_DR%20SUNIL.jpg',
    clinic: 'Kona Hospital',
    address: 'Tanuku, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD - Neuro Psychiatry', 'APMC Regn.no.: 81760', 'Mental Health Specialist'],
    consultationFee: 400,
    availableSlots: ['10:00 AM', '11:30 AM', '4:00 PM', '6:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Mental Health Advocate Consultant Neuro Psychiatrist with expertise in mental health, neurological disorders, and psychiatric care.',
    services: ['Neuro Psychiatry', 'Mental Health', 'Psychiatric Care', 'Neurological Disorders', 'Counseling']
  },
  {
    id: 12,
    name: 'Dr. Viswa Teja Vaitla',
    specialty: 'Surgeon & Trauma Care Specialist',
    qualification: 'MBBS, MS General Surgery',
    rating: 5.0,
    experience: 'Surgical Excellence',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/4es8yg3g_DR.%20VISWA%20TEJA.png',
    clinic: 'ARK Hospital',
    address: 'Rajamahendravaram, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MS General Surgery', 'APMC Regn.no.: 84000', 'Trauma Care Specialist'],
    consultationFee: 500,
    availableSlots: ['7:00 AM', '8:30 AM', '5:30 PM', '7:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Surgical Excellence Consultant Surgeon and Trauma Care Specialist with expertise in general surgery and emergency trauma procedures.',
    services: ['General Surgery', 'Trauma Care', 'Emergency Surgery', 'Surgical Procedures', 'Wound Care']
  },
  {
    id: 13,
    name: 'Dr. Vuyyuru Sasank',
    specialty: 'Radiologist & Ultrasonography Specialist',
    qualification: 'MBBS, MD Diagnostic Radiology',
    rating: 5.0,
    experience: 'Imaging Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/6nv30c2u_DR.%20VUYYURU%20SASANK.jpg',
    clinic: 'Ramesh Hospital',
    address: 'Vijayawada, Andhra Pradesh',
    distance: '1.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD Diagnostic Radiology', 'APMC Regn.no.: 79591', 'Ultrasonography Specialist'],
    consultationFee: 400,
    availableSlots: ['8:00 AM', '9:30 AM', '2:30 PM', '4:30 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Imaging Expert Consultant Radiologist and Ultrasonography Specialist with advanced expertise in diagnostic imaging and medical radiology.',
    services: ['Diagnostic Radiology', 'Ultrasonography', 'Medical Imaging', 'CT Scan', 'MRI Analysis']
  },
  {
    id: 14,
    name: 'Dr. Manobhiram Boggavarapu',
    specialty: 'Oncologist',
    qualification: 'MBBS, MS, DrNB Surgical Oncology',
    rating: 5.0,
    experience: 'Cancer Care Champion',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/es5oy0ka_DR%20MANOBHIRAM.jpg',
    clinic: 'Narayana Medical College And Hospital',
    address: 'Nellore, Andhra Pradesh',
    distance: '2.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MS, DrNB Surgical Oncology', 'APMC Regn.no.: 79513', 'Cancer Specialist'],
    consultationFee: 600,
    availableSlots: ['9:00 AM', '10:30 AM', '3:00 PM', '5:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Cancer Care Champion Consultant Oncologist with specialized expertise in surgical oncology and comprehensive cancer treatment.',
    services: ['Oncology Consultation', 'Cancer Treatment', 'Surgical Oncology', 'Chemotherapy', 'Cancer Care']
  },
  {
    id: 15,
    name: 'Dr. K Vigneswar Reddy',
    specialty: 'Physician & Telemedicine Specialist',
    qualification: 'MBBS, MD - Pharmacology',
    rating: 5.0,
    experience: 'Digital Health Pioneer',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/zz2yc96z_DR.%20K.%20VIGNESHWAR%20REDDY.jpg',
    clinic: 'GetSet Healthy',
    address: 'Kukatpally, Hyderabad',
    distance: '3.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD - Pharmacology', 'APMC Regn.no.: 79458', 'Telemedicine Specialist'],
    consultationFee: 350,
    availableSlots: ['10:00 AM', '12:00 PM', '4:00 PM', '6:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Digital Health Pioneer Consultant Physician and Telemedicine Specialist with expertise in pharmacology and remote healthcare delivery.',
    services: ['General Medicine', 'Telemedicine', 'Pharmacology', 'Remote Consultation', 'Digital Health']
  },
  {
    id: 16,
    name: 'Dr. E. Venkata Ravikanth',
    specialty: 'Dermatologist & Cosmetologist',
    qualification: 'MBBS, MD (DVL)',
    rating: 5.0,
    experience: 'Skin Care Master',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/j1nhstj9_DR%20RAVIKANTH.jpg',
    clinic: 'Dr. Ravi\'s Skin Hair and Laser Clinic',
    address: 'Chittor, Andhra Pradesh',
    distance: '1.5 km',
    phone: '7337541113',
    achievements: ['MBBS, MD (DVL)', 'APMC Regn.no.: 79516', 'Laser Treatment Specialist'],
    consultationFee: 400,
    availableSlots: ['9:00 AM', '10:30 AM', '3:00 PM', '5:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Skin Care Master Consultant Dermatologist and Cosmetologist with expertise in advanced skin treatments, hair care, and laser procedures.',
    services: ['Dermatology', 'Cosmetology', 'Laser Treatment', 'Hair Care', 'Skin Disorders']
  },
  {
    id: 17,
    name: 'Dr. K Ramakrishna Prasad',
    specialty: 'Sepsis & Critical Care Specialist',
    qualification: 'MBBS, MD - Sepsis Specialist',
    rating: 5.0,
    experience: 'Life Support Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/azm6kcz6_DR.%20RAMA%20KRISHNA.png',
    clinic: 'Shri Hospitals',
    address: 'Donka Road, Guntur, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD - Sepsis Specialist', 'APMC Regn.no.: 81925', 'Critical Care Expert'],
    consultationFee: 500,
    availableSlots: ['7:30 AM', '8:30 AM', '6:30 PM', '8:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Life Support Expert Consultant Sepsis and Critical Care Specialist with advanced training in sepsis management and intensive care protocols.',
    services: ['Sepsis Treatment', 'Critical Care', 'ICU Management', 'Emergency Medicine', 'Life Support Systems']
  },
  {
    id: 18,
    name: 'Dr. Datla VSLN Raju',
    specialty: 'Pediatrician & Neonatal Care Specialist',
    qualification: 'MBBS, MD Paediatrics',
    rating: 5.0,
    experience: 'Child Care Champion',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/1zi2r0yl_DR.%20DATLA%20VSN%20RAJU.jpg',
    clinic: 'Surya Hospital',
    address: 'Bhimavaram, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD Paediatrics', 'APMC Regn.no.: 79635', 'Neonatal Care Specialist'],
    consultationFee: 350,
    availableSlots: ['8:00 AM', '9:30 AM', '4:00 PM', '5:30 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Child Care Champion Consultant Pediatrician and Neonatal Care Specialist with expertise in child healthcare, newborn care, and pediatric medicine.',
    services: ['Pediatric Care', 'Neonatal Care', 'Child Health', 'Newborn Care', 'Pediatric Consultation']
  },
  {
    id: 19,
    name: 'Dr. DVSLN Krishnam Raju',
    specialty: 'Physician & Internal Medicine Specialist',
    qualification: 'MBBS, MD General Medicine',
    rating: 5.0,
    experience: 'Internal Medicine Expert',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/wy8onjgb_DR.%20DVSLN%20KRISHNAM%20RAJU.jpg',
    clinic: 'Sunrise Hospitals',
    address: 'Ganapavaram, Andhra Pradesh',
    distance: '1.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD General Medicine', 'APMC Regn.no.: 79631', 'Internal Medicine Specialist'],
    consultationFee: 350,
    availableSlots: ['8:30 AM', '10:00 AM', '3:30 PM', '5:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Internal Medicine Expert Consultant Physician and Internal Medicine Specialist with comprehensive expertise in general medicine and internal health management.',
    services: ['General Medicine', 'Internal Medicine', 'Physician Consultation', 'Health Management', 'Preventive Care']
  },
  {
    id: 20,
    name: 'Dr. C. Shravana Deepthi',
    specialty: 'Community Medicine Specialist',
    qualification: 'MBBS, MD Community Medicine',
    rating: 5.0,
    experience: 'Academic Excellence',
    photo: 'https://customer-assets.emergentagent.com/job_geeth365-health/artifacts/6q0owrd1_DR.%20C.%20SHRAVANA%20DEEPTHI.jpg',
    clinic: 'Apollo Medical College',
    address: 'Chittor, Andhra Pradesh',
    distance: '2.0 km',
    phone: '7337541113',
    achievements: ['MBBS, MD Community Medicine', 'APMC Regn.no.: 75753', 'Academic Specialist'],
    consultationFee: 300,
    availableSlots: ['8:00 AM', '9:00 AM', '11:00 AM', '4:00 PM'],
    languages: ['English', 'Telugu', 'Hindi'],
    about: 'Academic Excellence specialist in Community Medicine with expertise in preventive healthcare and public health programs.',
    services: ['Community Medicine', 'Preventive Healthcare', 'Public Health', 'Health Education', 'Vaccination Programs']
  }
];

export const mockSpecialties = [
  { id: 1, name: 'General Medicine' },
  { id: 2, name: 'Diabetologist & Physician' },
  { id: 3, name: 'Diabetology' },
  { id: 4, name: 'Dermatology' },
  { id: 5, name: 'Orthopedics' },
  { id: 6, name: 'Pediatrics' },
  { id: 7, name: 'Neurology' },
  { id: 8, name: 'Dermatologist & Cosmetology Specialist' },
  { id: 9, name: 'Community Medicine' },
  { id: 10, name: 'Gynecologist & Obstetrics Specialist' },
  { id: 11, name: 'Ophthalmologist & Cataract Specialist' },
  { id: 12, name: 'Cardiologist & Cardiac Stenting Specialist' },
  { id: 13, name: 'Pulmonologist & Emergency Care Specialist' },
  { id: 14, name: 'Critical Care & Sepsis Specialist' },
  { id: 15, name: 'Neuro Psychiatrist' },
  { id: 16, name: 'Surgeon & Trauma Care Specialist' },
  { id: 17, name: 'Radiologist & Ultrasonography Specialist' },
  { id: 18, name: 'Oncologist' },
  { id: 19, name: 'Physician & Telemedicine Specialist' },
  { id: 20, name: 'Dermatologist & Cosmetologist' },
  { id: 21, name: 'Sepsis & Critical Care Specialist' },
  { id: 22, name: 'Pediatrician & Neonatal Care Specialist' },
  { id: 23, name: 'Physician & Internal Medicine Specialist' }
];

export const mockPharmacyCategories = [
  {
    id: 1,
    name: 'Apollo Pharmacy',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    count: 45,
    description: 'Trusted healthcare brand with nationwide delivery'
  },
  {
    id: 2,
    name: 'MedPlus',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    count: 32,
    description: 'Quality medicines and healthcare products'
  },
  {
    id: 3,
    name: 'Netmeds',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    count: 28,
    description: 'Online pharmacy with fast delivery'
  },
  {
    id: 4,
    name: 'Cipla',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    count: 22,
    description: 'Leading pharmaceutical brand'
  },
  {
    id: 5,
    name: 'Sun Pharma',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    count: 35,
    description: 'Trusted generic and specialty medicines'
  },
  {
    id: 6,
    name: 'Dr. Reddy\'s',
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926',
    count: 18,
    description: 'Global pharmaceutical company'
  }
];

export const mockLabPackages = [
  {
    id: 1,
    name: 'Full Body Checkup',
    tests: ['CBC', 'Lipid Profile', 'LFT', 'KFT', 'Diabetes', 'Thyroid'],
    mrp: 2500,
    subscriberPrice: 1250,
    fasting: true,
    tat: 24,
    image: 'https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg'
  },
  {
    id: 2,
    name: 'Diabetes Package',
    tests: ['FBS', 'PPBS', 'HbA1c', 'Insulin'],
    mrp: 1200,
    subscriberPrice: 600,
    fasting: true,
    tat: 12,
    image: 'https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg'
  },
  {
    id: 3,
    name: 'Lipid Profile',
    tests: ['Total Cholesterol', 'HDL', 'LDL', 'Triglycerides'],
    mrp: 800,
    subscriberPrice: 400,
    fasting: true,
    tat: 6,
    image: 'https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg'
  },
  {
    id: 4,
    name: 'Thyroid Package',
    tests: ['TSH', 'T3', 'T4'],
    mrp: 900,
    subscriberPrice: 450,
    fasting: false,
    tat: 12,
    image: 'https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg'
  }
];

export const mockVitals = [
  {
    id: 1,
    kind: 'blood_pressure_systolic',
    value: 120,
    unit: 'mmHg',
    measuredAt: new Date('2024-01-15T10:30:00Z')
  },
  {
    id: 2,
    kind: 'blood_pressure_diastolic',
    value: 80,
    unit: 'mmHg',
    measuredAt: new Date('2024-01-15T10:30:00Z')
  },
  {
    id: 3,
    kind: 'blood_sugar_fasting',
    value: 95,
    unit: 'mg/dL',
    measuredAt: new Date('2024-01-14T08:00:00Z')
  },
  {
    id: 4,
    kind: 'cholesterol_total',
    value: 180,
    unit: 'mg/dL',
    measuredAt: new Date('2024-01-10T09:00:00Z')
  },
  {
    id: 5,
    kind: 'weight',
    value: 70,
    unit: 'kg',
    measuredAt: new Date('2024-01-15T07:00:00Z')
  },
  {
    id: 6,
    kind: 'height',
    value: 170,
    unit: 'cm',
    measuredAt: new Date('2024-01-01T10:00:00Z')
  }
];

export const mockUser = {
  id: 1,
  name: 'Rajesh Kumar',
  email: 'rajesh@example.com',
  phone: '9876543210',
  avatar: '👨‍💼',
  sex: 'male',
  dateOfBirth: '1985-06-15',
  subscriptionActive: true,
  addresses: [
    {
      id: 1,
      label: 'Home',
      line1: '10-68, PM Palem',
      line2: 'Near Apollo Hospital',
      city: 'Visakhapatnam',
      state: 'Andhra Pradesh',
      pincode: '530041',
      isDefault: true
    },
    {
      id: 2,
      label: 'Office',
      line1: '78-90-12, IT Hub',
      line2: 'HITEC City',
      city: 'Visakhapatnam',
      state: 'Andhra Pradesh',
      pincode: '530016',
      isDefault: false
    }
  ]
};

export const mockDoctorAchievements = [
  {
    id: 1,
    title: 'Apollo Excellence Award 2023',
    description: 'Best Patient Care',
    image: 'https://images.unsplash.com/photo-1751894051402-7cdb1753a653'
  },
  {
    id: 2,
    title: '10,000+ Successful Procedures',
    description: 'Cardiac Interventions',
    image: 'https://images.unsplash.com/photo-1751894051402-7cdb1753a653'
  },
  {
    id: 3,
    title: 'Medical Excellence Award',
    description: 'State Government Recognition',
    image: 'https://images.unsplash.com/photo-1751894051402-7cdb1753a653'
  }
];

// WhatsApp message generators
export const generateWhatsAppLink = (type, data) => {
  const baseUrl = 'https://wa.me/917337541113?text=';
  let message = '';

  // Construct user identification string with registration ID (matches backend subscription ID format)
  const getRegisteredId = (user) => {
    if (!user) return null;
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    return `G${user.id}${dd}${mm}${yyyy}`;
  };

  const userIdent = data.user
    ? `Registered ID: ${getRegisteredId(data.user)} | Name: ${data.user.first_name || data.user.name} | Phone: ${data.user.phone_number || 'N/A'}`
    : `Guest User`;

  switch (type) {
    case 'doctor':
      message = `Doctor Booking - ${userIdent}\nDoctor: ${data.doctorName}\nSpecialty: ${data.specialty}\nPreferred: ${data.preferredTime}\nLocation: ${data.location}`;
      break;
    case 'pharmacy':
      message = `Pharmacy Order - ${userIdent}\nAddress: ${data.address}\nItems: ${data.items || 'Prescription medicines'}\nCOD, Free Delivery`;
      break;
    case 'lab':
      message = `Lab Booking - ${userIdent}\nPackage: ${data.packageName}\nPreferred: ${data.preferredDate}\nAddress: ${data.address}\nCOD`;
      break;
    case 'subscription':
      message = `Subscription Request - Name: ${data.userName}, Email: ${data.email}, Phone: ${data.phone}, Age: ${data.age}`;
      break;
    default:
      message = `GEETH365 Healthcare - Query from ${userIdent}\nRequesting offer details`;
  }

  return baseUrl + encodeURIComponent(message);
};